<template>
  <div class="legal-container">
    <div class="legal-content">
      <h1>隐私政策</h1>
      <p class="last-updated">最后更新时间：2025年1月</p>

      <section>
        <h2>1. 信息收集</h2>
        <p>
          Xster 创意空间（"我们"、"我们的"或"本网站"）致力于保护您的隐私。当您访问我们的网站时，我们可能会收集以下类型的信息：
        </p>
        <ul>
          <li><strong>自动收集的信息：</strong>当您访问我们的网站时，我们可能会自动收集某些信息，包括您的IP地址、浏览器类型、访问时间、访问的页面以及您在我们网站上停留的时间。</li>
          <li><strong>Cookie和类似技术：</strong>我们使用Cookie和类似技术来改善用户体验、分析网站流量并个性化内容。您可以通过浏览器设置管理Cookie偏好。</li>
          <li><strong>Google Analytics：</strong>我们使用Google Analytics来分析网站使用情况，这可能涉及收集匿名的使用统计数据。</li>
        </ul>
      </section>

      <section>
        <h2>2. 信息使用</h2>
        <p>我们收集的信息用于以下目的：</p>
        <ul>
          <li>提供、维护和改进我们的服务</li>
          <li>分析网站使用情况以改善用户体验</li>
          <li>防止欺诈和滥用</li>
          <li>遵守法律义务</li>
        </ul>
      </section>

      <section>
        <h2>3. Google AdSense</h2>
        <p>
          我们的网站使用Google AdSense来展示广告。Google AdSense使用Cookie来根据您访问我们网站和其他网站的情况向您展示相关广告。您可以通过访问
          <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google广告设置</a>
          来选择退出基于兴趣的广告。
        </p>
        <p>
          第三方供应商（包括Google）使用Cookie来根据用户之前访问本网站和其他网站的情况投放广告。Google对DoubleClick Cookie的使用使其及其合作伙伴能够根据用户访问本网站和/或互联网上其他网站的情况投放广告。
        </p>
      </section>

      <section>
        <h2>4. 信息共享</h2>
        <p>我们不会出售、交易或出租您的个人信息给第三方。我们可能会与以下各方共享信息：</p>
        <ul>
          <li><strong>服务提供商：</strong>我们可能会与帮助我们运营网站的服务提供商共享信息，如Google Analytics和Google AdSense。</li>
          <li><strong>法律要求：</strong>如果法律要求或为了保护我们的权利，我们可能会披露信息。</li>
        </ul>
      </section>

      <section>
        <h2>5. 数据安全</h2>
        <p>
          我们采取合理的安全措施来保护您的个人信息免受未经授权的访问、使用或披露。但是，请注意，没有任何互联网传输或电子存储方法是100%安全的。
        </p>
      </section>

      <section>
        <h2>6. 您的权利</h2>
        <p>根据适用的数据保护法律，您有权：</p>
        <ul>
          <li>访问我们持有的关于您的个人信息</li>
          <li>要求更正不准确的信息</li>
          <li>要求删除您的个人信息</li>
          <li>反对处理您的个人信息</li>
          <li>撤回同意（如果处理是基于同意的）</li>
        </ul>
      </section>

      <section>
        <h2>7. 第三方链接</h2>
        <p>
          我们的网站可能包含指向第三方网站的链接。我们不对这些外部网站的隐私做法负责。我们鼓励您阅读这些网站的隐私政策。
        </p>
      </section>

      <section>
        <h2>8. 儿童隐私</h2>
        <p>
          我们的网站不面向13岁以下的儿童。我们不会故意收集13岁以下儿童的个人信息。如果您是父母或监护人，并且知道您的孩子向我们提供了个人信息，请联系我们。
        </p>
      </section>

      <section>
        <h2>9. 隐私政策的变更</h2>
        <p>
          我们可能会不时更新本隐私政策。我们将在本页面上发布任何更改，并更新"最后更新时间"。我们建议您定期查看本隐私政策以了解任何更改。
        </p>
      </section>

      <section>
        <h2>10. 联系我们</h2>
        <p>
          如果您对本隐私政策有任何问题或 concerns，请通过以下方式联系我们：
        </p>
        <p>
          邮箱：请联系我们通过网站上的联系页面<br/>
          网站：<router-link to="/contact">联系页面</router-link>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicyPage",
};
</script>

<style scoped>
.legal-container {
  position: relative;
  background: rgba(0, 68, 170, 0.3);
  overflow-y: auto;
  height: 80vh;
  padding: 20px;
  color: #f7f7f7;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.legal-container::-webkit-scrollbar {
  display: none;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
  line-height: 1.8;
}

.legal-content h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
  color: #fff;
}

.last-updated {
  color: rgba(255, 255, 255, 0.7);
  font-style: italic;
  margin-bottom: 30px;
}

.legal-content section {
  margin-bottom: 30px;
}

.legal-content h2 {
  font-size: 1.5em;
  margin-top: 25px;
  margin-bottom: 15px;
  color: #fff;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 5px;
}

.legal-content p {
  margin-bottom: 15px;
  text-align: justify;
}

.legal-content ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

.legal-content li {
  margin-bottom: 10px;
}

.legal-content a {
  color: #66b3ff;
  text-decoration: underline;
}

.legal-content a:hover {
  color: #99ccff;
}

@media (max-width: 768px) {
  .legal-content {
    padding: 10px;
  }

  .legal-content h1 {
    font-size: 2em;
  }

  .legal-content h2 {
    font-size: 1.3em;
  }
}
</style>

